import styled from 'styled-components'

export const PageWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1080px;
  padding: 0 0 48px;
`
